import { SWRConfiguration, SWRResponse } from 'swr'

import { V1Project, V1ProjectMethodsListResponse } from '@infura/packages.uks'

import useUser from 'hooks/useUser'

import { useUks } from 'lib/api/uks'

export function useUKSProjects(config?: SWRConfiguration & { disabled?: boolean }) {
  const { user } = useUser()
  const swr = useUks(!config?.disabled && user?.id ? ['projectMethodsList', user.id] : null, {
    ...config,
    revalidateOnFocus: false
  }) as SWRResponse<V1ProjectMethodsListResponse, any>
  return { projects: swr.data?.result?.projects ?? {}, ...swr }
}

export function useUKSProject(projectId: string, config?: SWRConfiguration) {
  const swr = useUks(projectId ? ['projectMethodsGet', projectId] : null, config)
  return { project: swr.data?.result as V1Project, ...swr }
}
